<details (toggle)="onToggle()" #details>
  <summary #summary role="button">
    <span>{{ header }}</span>
    <img class="arrow" alt="arrow" />
  </summary>
  <div>
    <ng-content></ng-content>
  </div>
</details>
